import React from "react"
import PropTypes from "prop-types"
import { Modal } from "react-bootstrap"
import { post } from "superagent"
import { browserHistory } from 'react-router'

import { getText } from '../lib/text'
import Button from '../components/Button'

class DocDetallesModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = { status: "wait", url: null, error: null }

    post(`/api/doc2/${this.props.trip._id}`)
      .send({})
      .end((e, r) => {
        if (e || !r) {
          this.setState({ status: "error", error: e || "UNKNOWN" })
        }
        else if (r.statusCode == 412) {
          this.setState({ status: "error", error: "missing_files" })
        }
        else if (r.statusCode == 401) {
          alert(getText("error_expired_login"))
          browserHistory.push("/login")
        }
        else {
          this.setState({ status: "done", url: r.text })
        }
      })
  }

  props: {
    trip: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired
  }

  render() {
    return (
      <Modal show onHide={() => this.props.close()}>
        <Modal.Header>
          <Modal.Title>
            Documento de detalles
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            this.state.status == "wait" && (
              <p>Cargando...</p>
            )
          }
          {
            this.state.status == "done" && (
              <div>
                <a href={this.state.url}>Descargar</a>
              </div>
            )
          }
          {
            this.state.status == "error" && (
              <p>ERROR: {this.state.error}</p>
            )
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.props.close()}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default DocDetallesModal
